import { render, staticRenderFns } from "./Short-URL.vue?vue&type=template&id=8e53003a"
import script from "./Short-URL.vue?vue&type=script&lang=js"
export * from "./Short-URL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports